import React from 'react';
import './IsLoading.scss';


class IsLoading extends React.Component {

    render() {
        
        return (
            <div className="IsLoading"><div></div><div></div><div></div><div></div></div>
        )
    }   
}

export default IsLoading;